export const cookieAllowlist = [
  'availability',
  'broadband_address',
  'broadband_postcode',
  'broadband_selected_provider',
  'broadband_selected_provider_id',
  'sskey',
  'uscd',
  'user_testing'
]
